import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creditbureau',
  templateUrl: './creditbureau.component.html',
  styleUrls: ['./creditbureau.component.css']
})
export class CreditbureauComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
